// store/forms/samplingEventForm/state.js

// Importing states from filters
import { samplingEventWellsFiltersInitialState } from "./filter/samplingEventWellsFiltersState";

// Calibration logs initial state
export const calibrationLogsInitialState = {
  loading: false,
  isModalOpen: false,
  modalHeaderString: "",
  currentLogId: null,
  isAddMode: false, // true when adding new logs, false when editing existing
  isDeleteConfirmOpen: false,
  logToDelete: null,
};

// Daily Summary UI initial state
export const dailySummaryUIInitialState = {
  loading: false,
  expandedCardId: null,
  isAddModalOpen: false,
  employeeModal: {
    isOpen: false,
    forSummaryId: null,
    selectedEmployees: [],
  },
  signatureModal: {
    isOpen: false,
    forSummaryId: null,
  },
  deleteSignatureConfirm: {
    isOpen: false,
    forSummaryId: null,
  },
  draftsBySummaryId: {}, // { [summaryId]: { notesDraft: string, maintenanceDraft: string } }
};

// Field Notes UI initial state
export const fieldNotesUIInitialState = {
  loading: false,
  activeTab: "myNotes", // "myNotes" | "groupNotes" | "allNotes"
  activeGroupId: null,
  isNoteModalOpen: false,
  isNoteAddMode: false, // true when adding new note, false when editing existing
  currentNoteId: null, // ID of note being edited (null for new notes)
  isFilterMenuOpen: false,
  isDeleteConfirmOpen: false,
  noteToDelete: null,
  filters: {
    date: null,
    employeeId: "",
    groupId: "",
  },
};

// Inspections UI initial state
export const inspectionsUIInitialState = {
  loading: false,
  expandedWellId: null,
  // Checking if the confirmation modal is open, mainly has to do with wiping out NAPL sections in the inspections so a user doesn't accidentally lose data.
  isConfirmationModalOpen: false,
  wellIdToConfirm: null,
  filters: samplingEventWellsFiltersInitialState,
};

// Wells UI initial state
export const wellsUIInitialState = {
  loading: false,
  // list controls
  expandedWellId: null,
  expandedGroupId: null,
  isConfirmationModalOpen: false,
  filters: samplingEventWellsFiltersInitialState,
  activeTab: "myGroupWells", // 'groupWells' | 'myGroupWells' | 'allWells'
  selectedWellIds: [],
  isFieldMeasurementModalOpen: false,
  isFieldMeasurementAddMode: false, // true when adding new measurement, false when editing
  isFieldMeasurementConfirmationModalOpen: false,
  isSamplerSignatureModalOpen: false,
  isQcSignatureModalOpen: false,
  isQcSignatureConfirmationModalOpen: false,
  isSamplerSignatureConfirmationModalOpen: false,
};

// JSA UI initial state (multiple JSAs per event)
export const jsaUIInitialState = {
  activeJsaId: null, // currently focused JSA id
  jsaUICommon: {
    isCopyModalOpen: false,
    isDeleteModalOpen: false,
  },
  jsaUIById: {
    // [jsaId]: {
    //   activeTab: "All", // or "Basic Info", "JHA", "Hazards", "Control Measures", "Signatures"
    //   signatureModal: { isOpen: false, signeeId: null },
    //   drafts: {}, // per-field drafts if needed
    //   validation: {},
    // }
  },
};

// Full Sampling Event Form UI initial state (single source of truth)
export const samplingEventFormInitialState = {
  rev: 0,
  dailySummaryUI: dailySummaryUIInitialState,
  calibrationLogUI: calibrationLogsInitialState,
  inspectionsUI: inspectionsUIInitialState,
  wellsUI: wellsUIInitialState,
  fieldNotesUI: fieldNotesUIInitialState,
  jsaUI: jsaUIInitialState, // keep nested
};
